export const EPermissionsKeys = {
  ALLOWED_TO_CHECK_TIMETRACKINGS: 'allowed_to_check_timetrackings',
  ALLOWED_TO_VIEW_LIMITED_LEAVES: 'allowed_to_view_limited_leaves',
  HAS_MOBILEZONE_ACCESS: 'has_mobilezone_access',
  EXCLUDE_DEPARTMENT_FROM_BANK_REPORT: 'exclude_department_from_bank_report',
  ALLOWED_TO_EXPORT_LEAVE_DOCUMENTS: 'can_export_leave_documents',
  ALLOWED_TO_SEE_STAFFING_REUQEST: 'allowed_to_see_staffing_request',
  ALLOW_MANAGER_TO_SEE_USERS_SALARY: 'allow_manager_to_see_users_salary',
  ALLOWED_TO_ACCESS_PERMISSIONS: 'allowed_to_access_permissions',
  ALLOWED_TO_SEE_MONTHLY_WORKING_HOURS: 'allowed_to_see_monthly_working_hours',
  ALLOWED_TO_SEE_REPORTS: 'allowed_to_see_reports',
  ALLOWED_TO_SEE_EXIT_LIST: 'allowed_to_see_exit_list',
  ALLOWED_TO_SEE_SALES_ORDERS: 'allow_to_see_sales_orders',
  ALLOWED_TO_MANUALLY_ADD_USER_WAGES: 'allowed_to_manually_add_user_wages',
  CAN_ACCESS_BILL_SYSTEM: 'can_access_bill_system',
  CAN_CREATE_BILL_TICKETS: 'can_create_billing_invoices',
  ALLOWED_TO_APPROVE_STAFFING_REQUEST: 'allowed_to_approve_staffing_request',
  ALLOWED_TO_EDIT_STAFFING_REQUEST: 'allowed_to_edit_staffing_request',
}
